import React from "react";
import { MenuItem } from "@mui/material";
import { MenuActions } from "pages/autorization-payments/components/MenuActions";
import { ButtonAction, ITableElement } from "shared/components";
import { accesRoles } from "shared/models";
import { ICostCenter } from "../models/ICostCenter";

export const columnsCostCenter = (
  onEdit?: (row: ICostCenter) => void,
  onInactivate?: (row: ICostCenter) => void,
  stateOptions?: any[],
): ITableElement<ICostCenter>[] => {
  return [
    {
      field: "codigoCentroCostos",
      headerName: "Código centro costos",
      minWidth: 180,
      renderCell(params: ICostCenter) {
        return React.createElement(
          React.Fragment,
          null,
          params.codigoCentroCostos ?? "",
        );
      },
    },
    {
      field: "nombre",
      headerName: "Nombre",
      minWidth: 180,
      renderCell(params: ICostCenter) {
        return React.createElement(React.Fragment, null, params.nombre ?? "");
      },
    },
    {
      field: "descripcionActividadProyecto",
      headerName: "Descripción",
      minWidth: 260,
      renderCell(params: ICostCenter) {
        return React.createElement(
          React.Fragment,
          null,
          params.descripcionActividadProyecto ?? "",
        );
      },
    },
    {
      field: "codigoConcepto",
      headerName: "Código concepto",
      minWidth: 160,
      renderCell(params: ICostCenter) {
        return React.createElement(
          React.Fragment,
          null,
          params.codigoConcepto ?? "",
        );
      },
    },
    {
      field: "cuentaContable",
      headerName: "Cuenta contable",
      minWidth: 150,
      renderCell(params: ICostCenter) {
        return React.createElement(
          React.Fragment,
          null,
          params.cuentaContable ?? "",
        );
      },
    },
    {
      field: "fuenteFinanciacion",
      headerName: "Fuente financiación",
      minWidth: 180,
      renderCell(params: ICostCenter) {
        return React.createElement(
          React.Fragment,
          null,
          params.fuenteFinanciacion ?? "",
        );
      },
    },
    {
      field: "inicioVigencia",
      headerName: "Inicio vigencia",
      minWidth: 140,
      renderCell(params: ICostCenter) {
        return React.createElement(
          React.Fragment,
          null,
          params.inicioVigencia ?? "",
        );
      },
    },
    {
      field: "finVigencia",
      headerName: "Fin vigencia",
      minWidth: 140,
      renderCell(params: ICostCenter) {
        return React.createElement(
          React.Fragment,
          null,
          params.finVigencia ?? "",
        );
      },
    },
    {
      field: "estado",
      headerName: "Estado",
      minWidth: 100,
      renderCell(params: ICostCenter) {
        const state = stateOptions?.find((s) => s.id === params.estado);
        return React.createElement(
          React.Fragment,
          null,
          state?.name ?? params.estado ?? "",
        );
      },
    },
    {
      field: "actions",
      headerName: "",
      minWidth: 120,
      renderCell(params: ICostCenter) {
        return React.createElement(
          MenuActions,
          null,
          React.createElement(
            MenuItem,
            null,
            React.createElement(
              ButtonAction,
              {
                roles: accesRoles.auditor,
                disabled: false,
                action: () => {
                  onEdit?.(params);
                },
              },
              React.createElement("span", null, "Editar"),
            ),
          ),
          React.createElement(
            MenuItem,
            null,
            React.createElement(
              ButtonAction,
              {
                roles: accesRoles.auditor,
                disabled: false,
                action: () => {
                  onInactivate?.(params);
                },
              },
              React.createElement("span", null, "Inactivar"),
            ),
          ),
        );
      },
    },
  ];
};
